import { SubmissionError } from 'redux-form';
import { acceptCoworkerInvitation } from '../signupActions';
import { validateEmail } from '../../../utils/validator';

const submit = (values, dispatch) => {
  if (!values.email) {
    throw new SubmissionError({
      email: 'Champ requis'
    });
  }
  if (values.email && !validateEmail(values.email)) {
    throw new SubmissionError({
      email: 'Adresse email invalide'
    });
  }

  if (!values.confirmationCode) {
    throw new SubmissionError({
      confirmationCode: 'Champ requis'
    });
  }

  if (values.confirmationCode) {
    const { email, confirmationCode } = values;
    dispatch(acceptCoworkerInvitation({ email, confirmationCode }));
  }
};

export default submit;
